import Cookies from 'js-cookie';
const TTL_MS = 1000; // 1 second
export const COOKIE_OPTION_KEYS = {
    httponly: 'httpOnly',
    maxage: 'maxAge',
    expires: 'expires',
    path: 'path',
    domain: 'domain',
    secure: 'secure',
    samesite: 'sameSite',
};
const cookieCache = new Map();
const lastCookieUpdateCache = new Map();
export const setCookie = (name, value, options) => {
    const now = Date.now();
    const lastUpdate = lastCookieUpdateCache.get(name);
    if (lastUpdate &&
        lastUpdate.ttl > now &&
        lastUpdate.value === value &&
        Object.keys(COOKIE_OPTION_KEYS).every((key) => lastUpdate.options?.[key] ===
            options?.[key])) {
        return;
    }
    const ttl = now + TTL_MS;
    cookieCache.set(name, {
        value,
        ttl,
    });
    lastCookieUpdateCache.set(name, {
        value,
        options,
        ttl,
    });
    return Cookies.set(name, value, options);
};
export const getCookie = (name) => {
    const cached = cookieCache.get(name);
    if (!cached || cached.ttl < Date.now()) {
        cookieCache.set(name, {
            value: Cookies.get(name),
            ttl: Date.now() + TTL_MS,
        });
    }
    return cookieCache.get(name)?.value;
};
export const removeCookie = (name, options) => {
    lastCookieUpdateCache.delete(name);
    cookieCache.delete(name);
    Cookies.remove(name, options);
};
export const getCookies = () => {
    return Cookies.get();
};
//# sourceMappingURL=provider.js.map